import {type ISavedCart} from '../schema';

export const canDeleteSavedCart = (savedCart?: Pick<ISavedCart, 'canManage'>) =>
	savedCart?.canManage === true;

export default canDeleteSavedCart;
